// extracted by mini-css-extract-plugin
export default {"container":"AllPosts_container__mM3NK"};